angular.module('messenger')

  .directive('onswAttachmentCreate', ['Widget', 'attachmentList', function (Widget, attachmentList) {
    return {
      scope: {
        datauploaded: '&?'
      },
      templateUrl: '/template/messenger.attachmentCreate',
      link: function (scope, element) {

        const widget = new Widget(scope, element, 'ons-form');

        scope.save = function () {
          scope.busy = true;
          widget.ifNotBusy(() => attachmentList.add(scope.image, scope.uploadName))
            .then(function (attachment) {
              widget.notify('core.saved');
              if (scope.datauploaded) {
                scope.datauploaded({ attachment: attachment });
              }
            })
            .catch(function (error) {
              if (error !== null) {
                widget.notify(error);
              }
            })
            .finally(function () {
              scope.uploadName = '';
              scope.image = null;
              scope.busy = false;
            });
        };
      }
    };
  }]);
